import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BuyDexscreenerReactions = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Dexscreener Reaction - Cheapest Dexmoji Rockets & Fire | Dexreaction</title>
        <meta name="description" content="Buy Dexscreener reaction at the lowest prices! Get Dexmoji rockets 🚀, fire 🔥, star ⭐ emojis starting at $0.05. Fastest delivery, natural patterns, 10% bonus reactions. #1 Dexscreener reaction bot!" />
        <meta name="keywords" content="buy dexscreener reaction, buy dexscreener reactions, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexreactions, dexscreener reaction, dexscreener reactions, buy dexmoji, dexscreener rockets, dexscreener fire reactions, dexscreener star reactions, crypto token boost, dexscreener trending, dexscreener reactions bot, telegram dexscreener bot, cheap dexscreener reactions" />
        <link rel="canonical" href="https://dexreaction.com/buy-dexscreener-reactions" />
        <meta property="og:title" content="Buy Dexscreener Reaction - Cheapest Dexmoji Service | Dexreaction" />
        <meta property="og:description" content="Buy Dexscreener reaction from $0.05! Rockets, fire, star emojis. Instant delivery, natural patterns, Telegram bot available!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://dexreaction.com/logo-light.png" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-purple-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button
                onClick={() => navigate('/')}
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
              >
                Get Started
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
              Buy DexScreener Reactions
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto">
              Boost Your Token's Social Proof with Authentic Reactions
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
              Increase visibility, attract more investors, and build credibility with real DexScreener reactions. Fast delivery and secure Solana payments.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105"
              >
                🚀 Buy Reactions Now
              </button>
              <button
                onClick={() => navigate('/')}
                className="bg-slate-800 hover:bg-slate-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all border border-purple-500/30"
              >
                View Pricing
              </button>
            </div>
          </div>
        </section>

        {/* Features Grid */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Buy DexScreener Reactions?
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-slate-800/50 border border-purple-500/20 rounded-xl p-6 hover:border-purple-500/50 transition-all">
                <div className="text-4xl mb-4">📈</div>
                <h3 className="text-xl font-bold mb-3">Increase Visibility</h3>
                <p className="text-gray-400">
                  Reactions boost your token's ranking on DexScreener, making it more discoverable to potential investors.
                </p>
              </div>
              <div className="bg-slate-800/50 border border-purple-500/20 rounded-xl p-6 hover:border-purple-500/50 transition-all">
                <div className="text-4xl mb-4">⚡</div>
                <h3 className="text-xl font-bold mb-3">Fast Delivery</h3>
                <p className="text-gray-400">
                  Get 500 reactions delivered every 10 minutes. Your order starts processing immediately after payment.
                </p>
              </div>
              <div className="bg-slate-800/50 border border-purple-500/20 rounded-xl p-6 hover:border-purple-500/50 transition-all">
                <div className="text-4xl mb-4">🎁</div>
                <h3 className="text-xl font-bold mb-3">20% Bonus Free</h3>
                <p className="text-gray-400">
                  Every purchase includes 20% extra reactions at no additional cost. Buy 1000, get 1200 reactions total!
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Available Reactions */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Available DexScreener Reactions
            </h2>
            <div className="grid md:grid-cols-5 gap-6">
              {[
                { emoji: '🚀', name: 'Rocket', desc: 'Bullish & Trending' },
                { emoji: '🔥', name: 'Fire', desc: 'Hot & Popular' },
                { emoji: '💩', name: 'Poop', desc: 'Bearish Sentiment' },
                { emoji: '🚩', name: 'Red Flag', desc: 'Warning Signal' },
                { emoji: '⭐', name: 'Favorite', desc: 'Community Love' }
              ].map((reaction) => (
                <div key={reaction.name} className="bg-slate-800/50 border border-purple-500/20 rounded-xl p-6 text-center hover:border-purple-500/50 transition-all">
                  <div className="text-5xl mb-3">{reaction.emoji}</div>
                  <h3 className="text-lg font-bold mb-2">{reaction.name}</h3>
                  <p className="text-sm text-gray-400">{reaction.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Transparent Pricing
            </h2>
            <p className="text-center text-gray-400 mb-12 text-lg">
              Just $0.05 per reaction. No hidden fees, no subscription required.
            </p>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { qty: 500, price: 25, total: 600 },
                { qty: 1000, price: 50, total: 1200 },
                { qty: 1500, price: 75, total: 1800 },
                { qty: 2000, price: 100, total: 2400 }
              ].map((pkg) => (
                <div key={pkg.qty} className="bg-gradient-to-br from-purple-900/30 to-pink-900/30 border-2 border-purple-500/30 rounded-xl p-6 hover:border-purple-500 transition-all">
                  <div className="text-center mb-4">
                    <span className="bg-purple-500/20 text-purple-300 px-3 py-1 rounded-full text-sm font-semibold">
                      +20% BONUS
                    </span>
                  </div>
                  <div className="text-3xl font-bold text-center mb-2">{pkg.qty}</div>
                  <div className="text-gray-400 text-center mb-4">Reactions</div>
                  <div className="text-4xl font-bold text-center mb-2 text-purple-400">
                    ${pkg.price}
                  </div>
                  <div className="text-center text-sm text-gray-400 mb-4">
                    Get {pkg.total} total!
                  </div>
                  <button
                    onClick={() => navigate('/')}
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors"
                  >
                    Buy Now
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How to Buy DexScreener Reactions
            </h2>
            <div className="space-y-6">
              {[
                { step: 1, title: 'Choose Your Package', desc: 'Select the number of reactions you want to buy. All packages include 20% bonus reactions.' },
                { step: 2, title: 'Select Reaction Type', desc: 'Pick from Rocket 🚀, Fire 🔥, Poop 💩, Red Flag 🚩, or Favorite ⭐ reactions.' },
                { step: 3, title: 'Enter Token Link', desc: 'Provide your DexScreener token link where you want the reactions delivered.' },
                { step: 4, title: 'Pay with Solana', desc: 'Complete payment using Solana. We accept wallet payments and manual transfers.' },
                { step: 5, title: 'Get Reactions Fast', desc: 'Reactions start delivering immediately at 500 reactions per 10 minutes.' }
              ].map((item) => (
                <div key={item.step} className="flex gap-4 bg-slate-800/50 border border-purple-500/20 rounded-xl p-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center text-xl font-bold">
                    {item.step}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-gray-400">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Frequently Asked Questions
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: 'How long does delivery take?',
                  a: 'Reactions start delivering immediately after payment verification. We deliver 500 reactions every 10 minutes to ensure natural delivery.'
                },
                {
                  q: 'Are the reactions real and safe?',
                  a: 'Yes, all reactions are delivered through authentic accounts and comply with DexScreener guidelines. Your token will not be flagged or penalized.'
                },
                {
                  q: 'What payment methods do you accept?',
                  a: 'We accept Solana (SOL) payments through wallet connection or manual transfer. All payments are secure and processed instantly.'
                },
                {
                  q: 'Can I split reactions across different tokens?',
                  a: 'Each order is for a single DexScreener token link. For multiple tokens, please place separate orders.'
                },
                {
                  q: 'What if I need more than 2000 reactions?',
                  a: 'You can enter a custom quantity (minimum 500, increments of 100) or place multiple orders for larger campaigns.'
                }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-purple-500/20 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-2">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Boost Your Token?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join hundreds of successful token launches using Dexreaction reactions
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              Start Boosting Now →
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-purple-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-purple-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-purple-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-purple-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BuyDexscreenerReactions;
